import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandling } from './errorHandling';

const LazyShopMenu = React.lazy(() => import('Products/ShopMenu').catch(errorHandling));

const ShopMenuLoader = () => (
    <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<div></div>}>
            <LazyShopMenu />
        </Suspense>
    </ErrorBoundary>
);

export default ShopMenuLoader;
